import { useMemo } from "react";
import { queries } from "../../shared/queries";
import type { GrantEntry } from "../../shared/rbac/roles";
import { defaultConnectorGrants } from "../../shared/rbac/connectorGrantsForSpace";
import { useCurrentUserId } from "./useCurrentUserId";
import { useHasAccess } from "./useHasAccess";
import { useQuery } from "@rocicorp/zero/react";

export function useDefaultConnectorGrants(
  spaceId?: string
): GrantEntry[] | undefined {
  const userId = useCurrentUserId();
  const [spaceGrants, spaceGrantsResult] = useQuery(
    spaceId ? queries.roleGrantsByScope({ scopeId: spaceId }) : undefined
  );
  const [currentUserGroups] = useQuery(queries.currentUserGroups());
  const creatorCanShare = useHasAccess("tenant:connected_app_share");

  const userGroupIds = useMemo(
    () => new Set(currentUserGroups.map((g) => g.id)),
    [currentUserGroups]
  );

  return defaultConnectorGrants({
    userId,
    spaceId,
    spaceGrants: spaceGrants ?? [],
    spaceGrantsLoaded: spaceGrantsResult?.type === "complete",
    userGroupIds,
    creatorCanShare,
  });
}
